import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { Menu as MenuIcon } from "@material-ui/icons";
import {
  Grid,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
} from "@material-ui/core";
import { message, Modal, Select } from "antd";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { changeStatus } from "../redux/OnlineStatusRedux/Action";
import { ROLES, warehouseId } from "../constants";
import {
  userOnlineAction,
  getDeskNumberAction,
} from "../redux/StatusRedux/Action";
import { fetchDeskDetailsThunk } from "../redux/newCheckerRedux/Action";
import { useLocation } from "react-router-dom";
import {
  MdOutlineDesktopWindows,
  MdOutlineDesktopAccessDisabled,
} from "react-icons/md";
import TMWhiteIcon from "../assets/icons/tmIconwhite.svg";
import { BuildVersion, PortalName } from "./VersionText";

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
  box-shadow: var(--shadow);
`;

const { Option } = Select;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

export const TMHeadrLogo = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 5px;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};

  p {
    margin: 0;
    font-weight: 600;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 5px;
    span {
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 1px;
      opacity: 0.75;
      margin-top: 4px;
    }
  }

  img {
    max-width: 16px;
  }
`;

export const TMOnlineToggle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
  .icon {
    background: ${(props) => (props.online ? "#31e996" : "#b8c2cc")};
    border-radius: 5px;
    font-size: 10px;
    font-weight: 600;
    padding: 2px 7px;
    text-transform: uppercase;
    box-shadow: var(--shadow);
    color: #000;
    letter-spacing: 0.75px;
  }
`;

const TMDeskSelector = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
  background: ${(props) => (props.active ? "#2f65cb" : "#aaa")};
`;

const AppBarComponent = (props) => {
  const location = useLocation();
  const historyData = location.state;
  const [checkerUser, setcheckerUser] = useState(null);
  const [pickFlow, setPickFlow] = useState(null);
  const [BooleanValue, setBooleanValue] = useState([true, false]);
  const [deskSelectModal, setDeskSelectModal] = useState(false);
  const [disableBtns, setDisableBtns] = useState(false);
  const [deskData, setDeskData] = useState(null);

  useEffect(() => {
    if (
      window.location.href.includes("/picker-order/") ||
      window.location.href.includes("/checker-order/") ||
      window.location.href.includes("/MissingZone") ||
      window.location.href.includes("/to-picker-order/") ||
      window.location.href.includes("/to-checker-order/") ||
      window.location.href.includes("/to-checker-box-process/") ||
      window.location.href.includes("/to-picker-order-process/") ||
      window.location.href.includes("/to-checker-order-process/")
    ) {
      setDisableBtns(true);
    } else {
      setDisableBtns(false);
    }

    if (
      props.userRole &&
      props.userRole.find(
        (o) =>
          o.roleName === ROLES.CHECKER_ROLE ||
          o.roleName === ROLES.ADMIN_CHECKER_ROLE ||
          o.roleName === ROLES.DISPATCH_ROLE ||
          o.roleName === ROLES.TO_CHECKER_ROLE
      )
    ) {
      setcheckerUser("CHECKERDISPATCH");
      document.title = "Truemeds - Checker";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("pickerFlow")) === true ||
      JSON.parse(localStorage.getItem("pickerFlow")) === false
    ) {
      setPickFlow(JSON.parse(localStorage.getItem("pickerFlow")));
    } else {
      pickerFlowSet();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      props.userRole &&
      props.isOnline &&
      !deskData &&
      props.userRole.find(
        (o) =>
          o.roleName === ROLES.CHECKER_ROLE ||
          o.roleName === ROLES.ADMIN_CHECKER_ROLE ||
          o.roleName === ROLES.DISPATCH_ROLE ||
          o.roleName === ROLES.TO_CHECKER_ROLE ||
          o.roleName === ROLES.TO_PACKER_ROLE ||
          o.roleName === ROLES.TO_DISPATCH_ROLE
      )
    ) {
      getDeskInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOnline, deskData]);

  const pickerFlowSet = () => {
    var index = Math.round(Math.random());
    localStorage.setItem("pickerFlow", JSON.stringify(BooleanValue[index]));
  };

  const getDeskInfo = () => {
    let data = {
      access_token: props.access_token,
      warehouseId: warehouseId,
    };
    props.fetchDeskDetailsThunk(data).then(() => {
      setTimeout(() => {
        props.history.push({
          state: {
            ...historyData,
            deskData: props.checkerDetails?.deskDetails,
          },
        });
        setDeskData(props.checkerDetails?.deskDetails);
        if (props.checkerDetails?.deskDetails?.deskDetailsList?.length === 1) {
          handleChangeDesk(
            props.checkerDetails?.deskDetails?.deskDetailsList?.[0]?.deskNumber
          );
        }
      });
    }, 500);
  };

  const changeStatus = async (statusId) => {
    let values = {
      status: statusId,
      access_token: props.access_token,
      userLoggedIn: false,
    };
    message.loading("Updating...", 0);
    await props.changeStatus(values).then(async () => {
      message.destroy();
      if (props.onlineCheck?.isUserOnineError?.response === "Network Error") {
        message.error("Session expired, please log in again");
        props.history.push("/");
      }
    });
  };

  const switchHandleChange = async (e) => {
    if (e) {
      await changeStatus(3);
      props.userOnlineAction(true);
    } else {
      await changeStatus(2);
      props.userOnlineAction(false);
    }
  };

  const handleChangeDesk = (value) => {
    props.getDeskNumberAction(value);
    setDeskSelectModal(false);
  };

  return (
    <React.Fragment>
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
          <Grid container alignItems="center" justify="space-between">
            <Grid item>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={props.onDrawerToggle}
                disabled={disableBtns}
              >
                <MenuIcon />
              </IconButton>
            </Grid>

            <TMHeadrLogo disabled={disableBtns}>
              <img src={TMWhiteIcon} alt="logo" />

              <p>
                {PortalName}
                <span>v{BuildVersion}</span>
              </p>
            </TMHeadrLogo>

            <div className="centerAppbarDiv">
              {props.isOnline && checkerUser === "CHECKERDISPATCH" ? (
                <TMDeskSelector
                  active={props.deskNumber}
                  disabled={disableBtns}
                  onClick={() => {
                    if (!disableBtns) {
                      setDeskSelectModal(true);
                      getDeskInfo();
                    }
                  }}
                >
                  {props.deskNumber ? (
                    <MdOutlineDesktopWindows />
                  ) : (
                    <MdOutlineDesktopAccessDisabled />
                  )}
                </TMDeskSelector>
              ) : (
                ""
              )}

              <TMOnlineToggle
                disabled={disableBtns}
                online={props.isOnline}
                onClick={() =>
                  !disableBtns && switchHandleChange(!props.isOnline)
                }
              >
                <div className="icon">
                  {props.isOnline ? "Online" : "Offline"}
                </div>
              </TMOnlineToggle>
            </div>
            <Modal
              title="Select Desk to continue"
              open={
                (props.checkerDetails?.deskDetails?.deskDetailsList?.length >
                  1 &&
                  props.isOnline &&
                  deskSelectModal &&
                  checkerUser === "CHECKERDISPATCH") ||
                (props.isOnline &&
                  props.checkerDetails?.deskDetails?.deskDetailsList?.length >
                    1 &&
                  checkerUser === "CHECKERDISPATCH" &&
                  !props.deskNumber)
              }
              footer={null}
              centered
              closable={false}
              onCancel={() => {
                if (props.deskNumber) {
                  setDeskSelectModal(false);
                }
              }}
            >
              <Select
                placeholder="Select Desk"
                style={{ width: "100%" }}
                onChange={handleChangeDesk}
                value={props.deskNumber}
              >
                {props.checkerDetails?.deskDetails?.deskDetailsList.map(
                  (item, pos) => (
                    <Option key={pos} value={item.deskNumber}>
                      {item.deskNumber}
                    </Option>
                  )
                )}
              </Select>
            </Modal>
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userRole: state.authReducer?.AuthData?.userDTO?.role,
  userInfo: state.authReducer?.AuthData?.userDTO,
  onlineCheck: state.onlineStatusReducer,
  isOnline: state.statusReducer.isOnline,
  deskNumber: state.statusReducer.deskNumber,
  checkerDetails: state.newCheckerOrderReducer,
});

export default withRouter(
  connect(mapStateToProps, {
    changeStatus,
    userOnlineAction,
    fetchDeskDetailsThunk,
    getDeskNumberAction,
  })(AppBarComponent)
);
